<template>
  <div>
    <el-pagination background layout="prev, pager, next" :current-page="childMsg.currentPage"
        	:page-size="childMsg.pageSize" :total="childMsg.total" @current-change="handleCurrentChange"></el-pagination>
  </div>


</template>

<script>
	export default {
		name: 'newPage',
		props: ['childMsg'],
		data() {
			return {
				pageparm: {
					currentPage: this.childMsg.currentPage,
					pageSize: this.childMsg.pageSize
				}
			}
		},
		created() {},
		methods: {
			handleSizeChange(val) {
				/**
				 * 子传父
				 * 参数1 父元素方法
				 * 参数2 数据
				 */
				this.pageparm.pageSize = val
				this.$emit('callFather', this.pageparm)
			},
			handleCurrentChange(val) {
				/**
				 * 子传父
				 * 参数1 父元素方法
				 * 参数2 数据
				 */
				this.pageparm.currentPage = val
				this.$emit('callFather', this.pageparm)
			}
		}
	}
</script>

<style>
	.page-box {
		margin: 10px auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/newPage.vue